/* eslint-disable jsx-a11y/anchor-is-valid */
import { useState } from 'react';
import * as Yup from 'yup';
import clsx from 'clsx';
import { useFormik } from 'formik';
import { login } from '../core/_requests';
import { toAbsoluteUrl } from '../../../../_metronic/helpers';
import { jwtDecode } from 'jwt-decode';
import Cookies from 'js-cookie';
import request from '../../../../utils/request';
import { useDispatch } from 'react-redux';

import Captcha from '../../../components/Captcha';
import SimpleCaptcha from '../../../components/SimpleCaptcha';
import { appVersion } from '../../../../constants';
import { Link } from 'react-router-dom';

const CAPTCHA_FULL = process.env.REACT_APP_CAPTCHA_FULL;

const loginSchema = Yup.object().shape({
	email: Yup.string()
		.email('Wrong email format')
		.min(3, 'Minimum 3 symbols')
		.max(50, 'Maximum 50 symbols')
		.required('Email is required'),
	password: Yup.string()
		.min(3, 'Minimum 3 symbols')
		.max(50, 'Maximum 50 symbols')
		.required('Password is required'),
});

const initialValues = {
	email: '',
	password: '',
	captcha: '',
};

/*
	Formik+YUP+Typescript:
	https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
	https://medium.com/@maurice.de.beijer/yup-validation-and-typescript-and-formik-6c342578a20e
*/

export function Login() {
	const [loading, setLoading] = useState(false);
	const [captchaText, setCaptchaText] = useState('');
	const [captchaToken, setCaptchaToken] = useState('');
	const [attempt, setAttempt] = useState(1);

	const dispatch = useDispatch();

	const formik = useFormik({
		initialValues,
		/* validationSchema: loginSchema, */
		onSubmit: async (values, { setStatus, setSubmitting }) => {
			// if (values.captcha !== captchaText) {
			// 	return alert('Captcha is wrong.');
			// }
			Cookies.remove('token');
			localStorage.removeItem('userId');
			localStorage.removeItem('capelId');
			localStorage.removeItem('customerNumbers');
			localStorage.removeItem('customerNum');
			localStorage.removeItem('pelanggan');
			localStorage.removeItem('login');
			localStorage.removeItem('email');

			setLoading(true);
			try {
				const data: any = await login(
					values.email,
					values.password,
					captchaText,
					values.captcha,
					captchaToken
				);

				if (data?.data?.data?.token) {
					localStorage.setItem('name', data.data.data.name);
					localStorage.setItem('username', data.data.data.userName);
					setTimeout(() => {
						onGetUserIdentity(data.data.data, values.email);
					}, 200);
				} else {
					setStatus(data?.response?.data?.message || data?.data?.message || 'Wrong username or password or captcha.');
					setSubmitting(false);
					setLoading(false);
					setAttempt(attempt + 1);
				}
			} catch (error) {
				setLoading(false);
				setStatus(`Something wrong. ${error}`);
			}
		},
	});

	const onGetUserIdentity = async (data, email) => {
		var decoded: any = jwtDecode(data.token);
		await request
			.get(`/users/customernum/${decoded.UserID}`, null,
				{
					Authorization: `${data.token}`
				})
			.then((value) => {
				setLoading(false);
				if (value !== undefined) {
					localStorage.setItem(
						'customerNumbers',
						JSON.stringify(value.data)
					);
					Cookies.set('token', data.token);
					localStorage.setItem('userId', decoded.UserID);

					if (localStorage.getItem('capelId') === null) {
						if (
							value?.data &&
							value.data.length > 0 &&
							value.data[0].capelID !== ''
						) {
							localStorage.setItem(
								'capelId',
								value.data[0].capelID
							);
						}
					}

					if (localStorage.getItem('customerNum') === null) {
						if (
							value.data &&
							value.data.length > 0 &&
							value.data[0].custNumber !== '' &&
							value.data[0].custNumber !== null
						) {
							localStorage.setItem(
								'customerNum',
								value.data[0].custNumber
							);
							localStorage.setItem('pelanggan', 'true');
							setTimeout(() => {
								window.location.assign('/dashboard');
							}, 200);
						} else {
							localStorage.setItem('pelanggan', 'false');
							setTimeout(() => {
								window.location.assign('/gas-subscription/1');
							}, 200);
						}
					}

					if (localStorage.getItem('email') === null) {
						if (email) {
							localStorage.setItem('email', email);
						}
					}
				}
			});
	};

	return (
		<>
			<form
				className="form w-100 fv-plugins-bootstrap5 fv-plugins-framework"
				onSubmit={formik.handleSubmit}
				noValidate={true}
				id="kt_login_signin_form"
				autoComplete="off"
			>
				<div className="text-center mb-8">
					<img
						className="mx-auto"
						style={{ width: '100px' }}
						src={toAbsoluteUrl('/media/pgn/pgn-logo-pertiwi.png')}
						alt=""
					/>
				</div>
				{formik.status && (
					<div className="mb-8 alert light-red">
						<div className="alert-text font-weight-bold">
							{formik.status}
						</div>
					</div>
				)}
				<div className="fv-row mb-8">
					<label className="form-label fs-6 fw-bold text-dark">
						Email
					</label>
					<input
						placeholder="Email"
						{...formik.getFieldProps('email')}
						className={clsx('form-control bg-transparent')}
						// type="email"
						autoComplete="off"
					/>
					{formik.touched.email && formik.errors.email && (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">
								<span role="alert">{formik.errors.email}</span>
							</div>
						</div>
					)}
				</div>
				<div className="fv-row mb-3">
					<label className="form-label fw-bold text-dark fs-6">
						Password
					</label>
					<input
						placeholder="Password"
						type="password"
						autoComplete="off"
						{...formik.getFieldProps('password')}
						className={clsx('form-control bg-transparent')}
					/>
					{formik.touched.password && formik.errors.password && (
						<div className="fv-plugins-message-container">
							<div className="fv-help-block">
								<span role="alert">{formik.errors.password}</span>
							</div>
						</div>
					)}
				</div>
				<div className="d-flex flex-stack flex-wrap gap-3 fs-base fw-semibold mb-1">
					<div />
					{/* <Link
					to="/auth/forgot-password"
					className="link-primary text-own"
				>
					Forgot password?
				</Link> */}
					{/* <span
					className="text-muted text-own"
					style={{ cursor: 'not-allowed' }}
				>
					Forgot password?
				</span> */}
				</div>
				<div
					className="fv-row mb-0"
					style={{ display: 'flex', alignItems: 'center' }}
				>
					<div style={{ marginRight: '10px' }}>
						{
							(CAPTCHA_FULL == '1') ?
								<Captcha key={attempt}
									setCaptchaText={setCaptchaText}
									setCaptchaToken={setCaptchaToken}
								/> :
								<SimpleCaptcha key={attempt}
									setCaptchaText={setCaptchaText}
								/>
						}
					</div>
					<input
						style={{ width: '350px' }}
						placeholder="Type captcha here"
						type="text"
						autoComplete="off"
						{...formik.getFieldProps('captcha')}
						className={clsx('form-control bg-transparent')}
					/>
				</div>
				<div className="d-grid mb-8 mt-5">
					<button
						type="submit"
						id="kt_sign_in_submit"
						className="btn btn-primary own"
						disabled={formik.isSubmitting || !formik.isValid}
					>
						{!loading && (
							<span className="indicator-label">Sign in</span>
						)}
						{loading && (
							<span
								className="indicator-progress"
								style={{ display: 'block' }}
							>
								Please wait...
								<span className="spinner-border spinner-border-sm align-middle ms-2"></span>
							</span>
						)}
					</button>
					<div className="d-flex justify-content-center align-items-center w-100">
						<div className="d-block text-center">
							<div
								className="fw-semibold text-muted"
								style={{ marginTop: '25px' }}
							>
								from
							</div>
							<img
								style={{ width: '125px' }}
								src={toAbsoluteUrl('/media/misc/logo-pgn.png')}
								alt=""
							/>
						</div>
					</div>
				</div>

				<div className="text-muted text-center fw-semibold fs-6">
					New to Pertiwi?&nbsp;
					<Link to="/auth/registration" className="link-primary text-own">
						Sign up
					</Link>
				</div>
			</form>
			<div style={{ position: "absolute", bottom: "10px" }}><b>Version</b> {appVersion}</div>
		</>
	);
}
